import ProjectsNewFile from './ProjectsNewFile';

export default ProjectsNewFile;
